import React from 'react';
import SEOHead from '../components/SEOHead';

function SSSPage() {
  const questions = [
    {
      question: "Siparişim ne zaman kargoya verilir?",
      answer: "Hafta içi saat 15:00'e kadar verilen siparişleriniz aynı gün, 15:00'ten sonra ve hafta sonu verilen siparişleriniz ise bir sonraki iş günü kargoya teslim edilmektedir."
    },
    {
      question: "Kargo ücreti ne kadar?",
      answer: "Tüm siparişlerinizde kargo ücreti 50 TL'dir. 1000 TL ve üzeri alışverişlerinizde kargo ücretsizdir."
    },
    {
      question: "İade ve değişim şartlarınız nelerdir?",
      answer: "Kullanılmamış ve etiketi üzerinde olan tüm ürünleri, fatura tarihinden itibaren 14 gün içinde kolayca iade edebilir veya değiştirebilirsiniz. Detaylı bilgi için 'İptal ve İade Koşulları' sayfamızı inceleyebilirsiniz."
    },
    {
      question: "Hangi ödeme yöntemlerini kullanabilirim?",
      answer: "Kredi kartı, banka kartı ve havale/EFT yöntemleri ile güvenli bir şekilde ödeme yapabilirsiniz."
    }
  ];

  // FAQPage Schema.org structured data
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <>
      <SEOHead
        title="Sıkça Sorulan Sorular - Minela Kids"
        description="Minela Kids sipariş, kargo, iade ve ödeme süreçleri hakkında sıkça sorulan sorular ve cevapları. Merak ettiğiniz her şey burada."
        structuredData={faqSchema}
      />
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-brand-green mb-6 border-b pb-4">Sıkça Sorulan Sorular (S.S.S.)</h1>
        <div className="space-y-6">
          {questions.map((item, index) => (
            <div key={index}>
              <h2 className="text-lg font-semibold text-text-dark mb-2">{item.question}</h2>
              <p className="text-text-light leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default SSSPage;
